module.exports = __webpack_public_path__ + "media/images/pc/specials/common/benefit/benefit_photo_data-7b596f6f37e1442d5e84aaaf64c40086.jpg";